import React, { useMemo } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import EirVisitView from '../../Views/EirVisitView';
import VideoVisitAWView from '../../Views/VideoVisitAWView';
import ImgRadLabVisitView from '../../Views/ImgRadLabVisitView';
import VirtualAndOfficeVisitView from '../../Views/VirtualAndOfficeVisitView';

import { getPaymentDetails } from '../../../../utils/appointment';

import {
  AW_TYPE_CODE,
  IMAGING_TYPE_CODE,
  LAB_TYPE_CODE,
  OFFICE_VISIT_TYPE_CODE,
  URGENT_CARE_TYPE_CODE,
  VIRTUAL_VISIT_TYPE_CODE,
  TECH_CONNECT_CODE,
  URGENT_VISIT_TYPE_CODE,
  TELEMEDICINE_VISIT_TYPE_CODE,
  HOLD_MY_SPOT_VISIT_TYPE_CODE,
} from '../../../../../../constants';
import getVisitTypeName from '../../../../../../utils/appointments/getVisitTypeName';

const RenderVisitView = ({ appointment, providerContext, providerView }) => {
  const { formatMessage } = useIntl();

  const providerName = get(appointment, 'providerInfo.name');
  const patientName = get(appointment, 'patientUserInfo.displayableName');
  const code = get(appointment, 'visitType.code');

  const reasonType = getVisitTypeName({
    sourceOfCreation: get(appointment, 'sourceOfCreation'),
    defaultValue: get(appointment, 'reasonType.name'),
    formatMessage,
    visitTypeCode: code,
  });

  const service = get(appointment, 'service.name');
  const location = get(appointment, 'location.name');

  const personName = providerView ? patientName : providerName;

  const manageable =
    providerView || providerContext ? get(appointment, 'manageable') : true;

  const paymentDetails = useMemo(
    () => getPaymentDetails({ appointment, providerContext, formatMessage }),
    [appointment, providerContext],
  );

  const targetName = useMemo(() => {
    if (manageable) return personName;
    if (providerContext && !providerView) return personName;

    return formatMessage({ id: 'common.hidden' });
  }, [manageable, personName, providerContext, providerView]);

  switch (code) {
    case LAB_TYPE_CODE:
    case URGENT_CARE_TYPE_CODE:
    case IMAGING_TYPE_CODE:
    case TECH_CONNECT_CODE: {
      return (
        <ImgRadLabVisitView
          formatMessage={formatMessage}
          location={location}
          reasonType={reasonType}
        />
      );
    }

    case AW_TYPE_CODE: {
      return <VideoVisitAWView formatMessage={formatMessage} />;
    }

    case VIRTUAL_VISIT_TYPE_CODE:
    case URGENT_VISIT_TYPE_CODE: {
      return (
        <VirtualAndOfficeVisitView
          reasonType={reasonType}
          formatMessage={formatMessage}
          service={service}
          paymentDetails={paymentDetails}
          personName={targetName}
          providerView={providerView}
        />
      );
    }

    case HOLD_MY_SPOT_VISIT_TYPE_CODE:
    case TELEMEDICINE_VISIT_TYPE_CODE: {
      return (
        <EirVisitView
          service={service}
          reasonType={reasonType}
          paymentDetails={paymentDetails}
          providerView={providerView}
        />
      );
    }

    case OFFICE_VISIT_TYPE_CODE:
      return (
        <VirtualAndOfficeVisitView
          reasonType={reasonType}
          formatMessage={formatMessage}
          service={service}
          paymentDetails={paymentDetails}
          personName={targetName}
          providerView={providerView}
        />
      );

    default:
      return null;
  }
};

RenderVisitView.propTypes = {
  appointment: PropTypes.object.isRequired,
  providerContext: PropTypes.bool,
  providerView: PropTypes.bool,
};

export default RenderVisitView;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentCard/components/RenderVisitView/index.jsx